import { LocationLocale } from "../types/LocationLocale";

const GUEST_PLATFORM_FEE_LABEL = "Guest platform fee";

// Gated on the flag AND the venue's currency, never the flag alone: this app ships one global
// bundle to every region, and the AU deployment also serves NZD venues.
export const getProcessingFeeText = (locationLocale: LocationLocale, guestPlatformFeeEnabled?: boolean) => {
    if (guestPlatformFeeEnabled && locationLocale.currency?.toUpperCase() === "AUD") {
        return GUEST_PLATFORM_FEE_LABEL;
    }

    switch (locationLocale.locale) {
        case "en-GB":
            return "Administration fee";
        default:
            return "Card processing fee";
    }
};
